import { FC } from 'react'
import { useTranslation } from 'next-i18next'

import { IconVideoDownloaderDownload } from '@/components/common/Icons'

import { useHumanReadableDuration } from '../../common/hooks/duration'
import {
  ResultStepContainer,
  ResultStepDescriptionContainer,
  ResultStepDownloadButton,
  ResultStepDownloadContainer,
  ResultStepRestartButton,
  ResultStepDownloadTitle,
  ResultStepDuration,
  ResultStepThumbnail,
  ResultStepTitle,
} from '../../common/components/ResultStep'

type StepThreeProps = {
  videoTitle: string
  thumbnailUrl: string
  /**
   * units: seconds
   */
  duration: number
  onDownload: () => void

  className?: string
}

export const StepThree: FC<StepThreeProps> = ({
  videoTitle,
  thumbnailUrl,
  duration,
  onDownload,

  className,
}) => {
  const { t } = useTranslation('common')
  const humanReadableDuration = useHumanReadableDuration(duration)

  return (
    <ResultStepContainer className={className}>
      <ResultStepDescriptionContainer>
        <ResultStepTitle title={videoTitle}>{videoTitle}</ResultStepTitle>

        <ResultStepDuration>{humanReadableDuration}</ResultStepDuration>

        <ResultStepThumbnail $backgroundImage={thumbnailUrl} />
      </ResultStepDescriptionContainer>

      <ResultStepDownloadContainer>
        <ResultStepDownloadTitle>
          {t('Download for free!')}
        </ResultStepDownloadTitle>

        <ResultStepDownloadButton
          type="primary"
          size="large"
          onClick={onDownload}
        >
          <IconVideoDownloaderDownload />
          {t('Download')}
        </ResultStepDownloadButton>

        <ResultStepRestartButton
          type="link"
          size="large"
          href={`/tools/video-downloader`}
        >
          {t('Download another video')}
        </ResultStepRestartButton>
      </ResultStepDownloadContainer>
    </ResultStepContainer>
  )
}
